import { render, staticRenderFns } from "./TdRefundAccount.vue?vue&type=template&id=e67bd928&"
import script from "./TdRefundAccount.vue?vue&type=script&lang=ts&"
export * from "./TdRefundAccount.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports